import { Loader2 } from "lucide-react";
import { Badge } from "../../../../components/ui/badge";
import { TableCell, TableRow } from "../../../../components/ui/table";
import { OptroControlSummary } from "../../../../models/audit/optroSync";
import { ControlsColumnWidths } from "./controlsTableColumns";

// Stand-in for a control still importing from Optro, built from the import
// selection so the table has a row for it before the real one exists. Not
// clickable: there is no control to open yet. Cycle isn't in the Optro
// listing, so it fills in when the real row lands.
export const ImportingControlRow = ({
  control,
  columnWidths,
}: {
  control: OptroControlSummary;
  columnWidths: ControlsColumnWidths;
}) => (
  <TableRow
    aria-busy="true"
    className="gradient-sweep-row text-stone-400 hover:bg-transparent"
  >
    <TableCell
      className="border-x"
      style={{ width: columnWidths.name, maxWidth: columnWidths.name }}
    >
      <div className="flex items-center gap-2 overflow-hidden">
        {control.idCode && (
          <span className="shrink-0 font-mono text-xs">{control.idCode}</span>
        )}
        <p className="truncate" title={control.name}>
          {control.name}
        </p>
      </div>
    </TableCell>
    <TableCell
      className="text-sm border-r"
      style={{ width: columnWidths.process, maxWidth: columnWidths.process }}
    >
      <div className="truncate">{control.process || "-"}</div>
    </TableCell>
    <TableCell
      className="text-sm border-r"
      style={{ width: columnWidths.cycle, maxWidth: columnWidths.cycle }}
    >
      -
    </TableCell>
    <TableCell
      className="text-sm border-r"
      style={{ width: columnWidths.owner, maxWidth: columnWidths.owner }}
    >
      <div className="truncate">{control.owner || "-"}</div>
    </TableCell>
    <TableCell
      className="text-sm border-r"
      style={{ width: columnWidths.state, maxWidth: columnWidths.state }}
    >
      <Badge
        variant="secondary"
        className="gap-1.5 py-1 font-medium bg-stone-100 text-stone-500 hover:bg-stone-100"
      >
        <Loader2 className="h-3 w-3 animate-spin motion-reduce:animate-none" />
        Importing
      </Badge>
    </TableCell>
  </TableRow>
);
